// AuthApi.ts — the three calls the sign-in gate makes.
//
// ⚠ Sign-in is ALWAYS enforced. An earlier draft let a deployment with an empty Auth:GoogleClientId
// report `authDisabled` and waved the gate through, which meant a misconfigured host silently served
// the editor to anyone. Now an empty client id means NOBODY can sign in — /api/auth/config reports
// enabled:false, the panel says so, and the server still rejects every request.
async function getJson(url) {
    const response = await fetch(url, { credentials: "same-origin" });
    if (!response.ok) {
        throw new Error(`${url} -> HTTP ${response.status}`);
    }
    return (await response.json());
}
export function fetchAuthConfig() {
    return getJson("/api/auth/config");
}
export function fetchAuthState() {
    return getJson("/api/auth/me");
}
/** Hands Google's ID token to the server, which validates it and sets the cookie. */
export async function signInWithGoogle(idToken) {
    const response = await fetch("/api/auth/google", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idToken }),
    });
    if (response.ok) {
        return;
    }
    // The server's refusals are meaningful and worth showing verbatim: 403 is "right Google account,
    // wrong domain", which reads as a broken button unless it is said out loud.
    if (response.status === 403) {
        throw new Error("That account is outside the allowed domain.");
    }
    if (response.status === 401) {
        throw new Error("Google could not verify that sign-in. Try again.");
    }
    if (response.status === 503) {
        throw new Error("Sign-in is not configured on this server.");
    }
    throw new Error(`Sign-in failed (HTTP ${response.status}).`);
}
export async function signOut() {
    await fetch("/api/auth/logout", { method: "POST", credentials: "same-origin" });
}
